{
  "schemaVersion": 1,
  "slug": "miro",
  "name": "Miro",
  "description": "Connect Miro's provider-hosted MCP server.",
  "categories": [
    "productivity"
  ],
  "featured": false,
  "branding": {
    "logoUrl": "/brands/apps/miro.svg"
  },
  "urlPatterns": [
    "https://mcp.miro.com/*"
  ],
  "docsUrl": "https://help.miro.com/hc/en-us/articles/31625301583890-How-to-enable-Miro-s-MCP-Server-user-guide",
  "redirectConstraints": "https-or-loopback-http",
  "methods": [
    {
      "key": "mcp-oauth",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "dcr"
      ],
      "whenToUse": "Use browser sign-in for the provider-hosted MCP server.",
      "defaults": {
        "serverUrl": "https://mcp.miro.com/"
      },
      "guidanceMd": "Connect Miro in the browser. A Miro account; enterprise administrators may restrict third-party MCP clients.",
      "riskTier": "S3",
      "label": "Sign in with Miro",
      "consoleLinks": {
        "docs": "https://help.miro.com/hc/en-us/articles/31625301583890-How-to-enable-Miro-s-MCP-Server-user-guide"
      },
      "warnings": [
        "A Miro account; enterprise administrators may restrict third-party MCP clients."
      ]
    }
  ]
}
